import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';

@Component({
    selector: 're-permissions-required',
    templateUrl: './permissions-required.component.html',
    styleUrls: ['./permissions-required.component.scss'],
    standalone: false
})
export class PermissionsRequiredComponent implements OnInit {

  constructor(private location: Location) { }

  ngOnInit() {
  }

  goBack() {
    this.location.back();
  }

}
